import * as helper from './../../../../../VX/View/Assets/Js/helper';

export default class AlertBox {
	constructor(containerElement) {
		this.alertBox = containerElement.querySelector('.alertbox');
	}

	show(text) {
		this.alertBox.innerHTML = text;
		helper.removeClass(this.alertBox, 'hidden');
	}

	hide() {
		helper.addClass(this.alertBox, 'hidden');
	}
}
